var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-dropdown",attrs:{"uk-dropdown":"mode: click; delay-hide: 0; pos: bottom-right;","id":"edit-menu"}},[_c('ul',{staticClass:"uk-nav uk-dropdown-nav"},[_c('li',{on:{"click":_vm.editItem}},[_c('a',[_vm._v("Edit Value")])]),_c('li',{on:{"click":_vm.deleteItem}},[_c('a',[_vm._v("Delete")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }